import { 
  Lightbulb, 
  Thermometer, 
  Move, 
  DoorOpen, 
  Droplets, 
  Flame,
  Power,
  Zap,
  Sun,
  Wind,
  Tv,
  Blinds
} from 'lucide-react';
import type { DeviceType } from '../../api/types';

interface DeviceIconProps {
  type: DeviceType;
  isOnline?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function DeviceIcon({ type, size = 'md', className = '' }: DeviceIconProps) {
  const iconSizes = {
    sm: 18,
    md: 24,
    lg: 32
  };

  const getIcon = () => {
    switch (type) {
      case 'relay':
      case 'double_relay':
      case 'triple_relay':
        return <Lightbulb size={iconSizes[size]} className={className} />;
      case 'dimmer':
      case 'double_dimmer':
        return <Sun size={iconSizes[size]} className={className} />;
      case 'thermostatic_radiator_valve':
        return <Thermometer size={iconSizes[size]} className={className} />;
      case 'climate_sensor':
        return <Thermometer size={iconSizes[size]} className={className} />;
      case 'motion_sensor':
        return <Move size={iconSizes[size]} className={className} />;
      case 'door_sensor':
        return <DoorOpen size={iconSizes[size]} className={className} />;
      case 'water_leak_sensor':
        return <Droplets size={iconSizes[size]} className={className} />;
      case 'smoke_sensor':
      case 'gas_sensor':
        return <Flame size={iconSizes[size]} className={className} />;
      case 'socket':
        return <Power size={iconSizes[size]} className={className} />;
      case 'ir_remote_controller':
      case 'ir_device':
        return <Tv size={iconSizes[size]} className={className} />;
      case 'roller_driver':
        return <Blinds size={iconSizes[size]} className={className} />;
      case 'wire_device':
        return <Wind size={iconSizes[size]} className={className} />;
      default:
        return <Zap size={iconSizes[size]} className={className} />;
    }
  };

  return getIcon();
}
